<template>
  <div
    @click.stop="showModal"
    class="rounded-md w-12 h-12 flex items-center justify-center bg-indigo-100 cursor-pointer"
  >
    <div class="text-center scale-75 font-bold text-indigo-600">
      <ShieldCheckIcon class="h-10 w-10" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from '@/stores/modal'
import { ShieldCheckIcon } from '@heroicons/vue/20/solid'
import { format } from 'date-fns'
import VerifiedInfoModal from './VerifiedInfoModal.vue'
const { presentModal } = useModalStore()

const props = defineProps<{ verifiedAt: string }>()

const showModal = () => {
  presentModal({
    component: VerifiedInfoModal,
    componentProps: {
      title: `Verified by Crewdentials on ${format(new Date(props.verifiedAt), 'do MMM yyyy')}`,
      message: 'This document has been verified with the issuer by a member of our team.'
    }
  })
}

defineExpose({ showModal })
</script>
